import React from "react"
import { useState } from "react"
import BackdropContext from "./BackdropContext"

const BackdropProvider = (props) => {
  const [backdropOpen, setOpen] = useState(false)

  const openBackdrop = () => setOpen(true)
  const closeBackdrop = () => setOpen(false)

  return <BackdropContext.Provider value={{ backdropOpen, openBackdrop, closeBackdrop }}>{props.children}</BackdropContext.Provider>
}

export default BackdropProvider
